import { render, staticRenderFns } from "./HotText.vue?vue&type=template&id=42805f98&"
import script from "./HotText.vue?vue&type=script&lang=js&"
export * from "./HotText.vue?vue&type=script&lang=js&"
import style0 from "./HotText.vue?vue&type=style&index=0&id=42805f98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports